/**
 * Formatta qualsiasi data in GG/MM/AAAA (standard italiano, usato in tutto il CRM).
 * Accetta ISO string (2026-02-15 / 2026-02-15T10:00:00Z), Date, o null.
 */
export const formatDate = (value) => {
  if (!value) return '-';
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const d = new Date(s);
  if (!isNaN(d.getTime())) return d.toLocaleDateString('it-IT');
  return s;
};
